import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from '../../assets/styles/style.sass';
import s2 from './login.sass';
// import LoginRegisterMessagesRef from './LoginRegisterMessageRef';
import {
  setIsShowLoginModal,
  setIsShowRegisterModal,
  setIsShowUpdateUserModal,
} from '../../actions/user';
// const messagesRef = LoginRegisterMessagesRef;

class LoginModuleRedirectText extends React.Component {
  static propTypes = {
    currentLocale: PropTypes.string.isRequired,
    // lang: PropTypes.string.isRequired,
    normalText: PropTypes.string.isRequired,
    btnText: PropTypes.string.isRequired,
    target: PropTypes.string.isRequired,
    isShowRegisterModal: PropTypes.bool.isRequired,
    isShowUpdateUserModal: PropTypes.bool.isRequired,
    setIsShowLoginModal: PropTypes.func.isRequired,
    setIsShowRegisterModal: PropTypes.func.isRequired,
    setIsShowUpdateUserModal: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      normalText: props.normalText,
      btnText: props.btnText,
    };
    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    if (this.props.isShowRegisterModal) {
      this.props.setIsShowRegisterModal();
    }
    if (this.props.isShowUpdateUserModal) {
      this.props.setIsShowUpdateUserModal();
    }
    this.props.setIsShowLoginModal();
  }

  render() {
    return (
      <div className={`${s.globalFontLight} ${s2.redireactText}`}>
        {typeof this.props.currentLocale !== 'undefined' &&
        this.props.currentLocale === 'ko-KR' ? (
          <span>
            {this.state.normalText}
            <span
              className={`${s.globalTextBlue} ${s.cursorPointer} ${
                s.dialog
              } dialog-change`}
              data-target={this.props.target}
              role="button"
              tabIndex={0}
              onClick={() => this.toggle()}
              onKeyPress={() => {}}
            >
              {this.state.btnText}
            </span>
          </span>
        ) : (
          <span>
            <span
              className={`${s.globalTextBlue} ${s.cursorPointer} ${
                s.dialog
              } dialog-change`}
              data-target={this.props.target}
              role="button"
              tabIndex={0}
              onClick={() => this.toggle()}
              onKeyPress={() => {}}
            >
              {this.state.btnText}
            </span>
            {this.state.normalText}
          </span>
        )}
      </div>
    );
  }
}
const mapState = state => ({
  email: state.user.email,
  password: state.user.password,
  currentLocale: state.intl.locale,
  isShowLoginModal: state.user.isShowLoginModal,
  isShowRegisterModal: state.user.isShowRegisterModal,
  isShowUpdateUserModal: state.user.isShowUpdateUserModal,
});
const mapDispatch = {
  setIsShowLoginModal,
  setIsShowRegisterModal,
  setIsShowUpdateUserModal,
};
export default connect(mapState, mapDispatch)(
  withStyles(s, s2)(LoginModuleRedirectText),
);



// WEBPACK FOOTER //
// ./src/components/Login/LoginModuleRedirectText.js